var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.008 5.816c.47 0 2.155.042 3.264 1.631-.096.075-1.77 1.024-1.77 3.136 0 2.443 2.133 3.307 2.197 3.328-.01.054-.341 1.184-1.13 2.336-.705 1.014-1.44 2.027-2.56 2.027s-1.409-.65-2.689-.65c-1.269 0-1.717.671-2.741.671s-1.739-.938-2.55-2.09c-.96-1.355-1.727-3.456-1.727-5.45 0-3.2 2.08-4.897 4.128-4.897 1.088 0 1.994.715 2.688.715.64 0 1.653-.758 2.89-.758Zm-.576-1.355c-.554.672-1.493 1.173-2.24 1.173a1.2 1.2 0 0 1-.213-.021 1.464 1.464 0 0 1-.032-.299c0-.853.437-1.696.896-2.23.597-.692 1.6-1.215 2.421-1.247.022.096.032.213.032.33 0 .843-.362 1.686-.864 2.294Z",
    fill: "currentColor"
  })));
};
export default SvgApple;